<template>
  <div>
    <vxe-toolbar size="mini" v-if="!isHiddenBtn">
      <template v-slot:buttons>
        <template>
          <el-button type="primary" size="small" class="vxe-btn-primary" @click="addNewRowHandler"
            >新增</el-button
          >
          <el-button
            size="small"
            type="danger"
            class="vxe-btn-delete"
            @click="deleteBtnClickHandler()"
            >删除</el-button
          >
        </template>
      </template>
    </vxe-toolbar>
    <!---可编辑表格-->
    <vxe-grid
      border
      show-overflow
      resizable
      ref="xTableRef"
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :data="tableData"
      :columns="tableColumnsList"
      :edit-rules="tableRules"
      :edit-config="editConfig"
      :valid-config="{ autoPos: true, message: 'inline' }"
      :show-footer="true"
      :footer-method="footerMethod"
      @edit-closed="closeEditTableHandler"
      @radio-change="handleSelectionChange"
    >
    </vxe-grid>
  </div>
</template>

<script>
  export default {
    name: 'SettleAccountsRowTable',
    props: {
      fetchTableData: {
        type: Array,
        default: () => [],
      },
      baseFormData: {
        type: Object,
        default: () => {},
      },
      isCreate: {
        type: Boolean,
        default: false,
      },
      defaultSelection: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        tableData: [],
        selectionList: [],
        editConfig: { trigger: 'click', mode: 'row' },
        isHiddenBtn: false,
        tableRules: {
          settlementDesc: [
            { required: true, message: '必填字段' },
            { min: 2, max: 20, message: '长度在 2 到 20 个字符' },
          ],
          originalAmount: [{ required: true, message: '必填字段' }],
        },
        ids: [], // 被删除的数据id集合
      };
    },
    computed: {
      tableColumnsList() {
        return [
          { type: 'radio', width: 50 },
          { type: 'seq', title: '序号', width: 50 },
          {
            field: 'settlementDesc',
            title: '结算说明',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            width: 120,
          },
          {
            field: 'expenseTypeName',
            title: '费用类型',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
                disabled: true,
              },
            },
            width: 120,
          },
          {
            field: 'originalPrice',
            title: '原币结算单价（含税）',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
                disabled: true,
              },
            },
            // slots: {
            //   default: ({ row }) => {
            //     return [<span>{row['originalPrice']}</span>];
            //   },
            //   edit: ({ row }) => {
            //     return [
            //       <InputNumberAd
            //         value={row['originalPrice']}
            //         max={999999999.999999}
            //         min={0}
            //         precision={6}
            //         onInput={(val) => this.updateCol(row, val, 'originalPrice')}
            //       ></InputNumberAd>,
            //     ];
            //   },
            // },
            width: 180,
          },
          {
            field: 'settlementQuantity',
            title: '结算数量',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
                placeholder: '请输入结算数量',
                disabled: true,
              },
              // events: {
              //   // change: (obj) => this.updateCol(obj.row, obj.row['builtArea'], 'builtArea'),
              //   input: (obj) => this.updateCol(obj.row, obj.row['builtArea'], 'builtArea'),
              // onInput={(val) => this.chooseTable(val, row, 'serviceCycle')}
              // },
            },
            //                     onInput={(val) => this.updateCol(row, val, 'settlementQuantity')}
            slots: {
              default: ({ row }) => {
                return [<span>{row['settlementQuantity']}</span>];
              },
              edit: ({ row }) => {
                return [
                  <InputNumberAd
                    value={row['settlementQuantity']}
                    max={999999999.999999}
                    min={0}
                    precision={4}
                    onInput={(val) => this.updateCol(row, val, 'settlementQuantity')}
                  ></InputNumberAd>,
                ];
              },
            },
            width: 120,
          },
          {
            field: 'unitName',
            title: '计量单位',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
                disabled: true,
              },
            },
            width: 120,
          },
          {
            field: 'originalAmount',
            title: '原币结算金额(含税)',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
                disabled: true,
              },
              // events: {
              //   input: (obj) =>
              //     this.updateCol(obj.row, obj.row['chargeUnitPrice'], 'chargeUnitPrice'),
              // },
            },
            // slots: {
            //   default: ({ row }) => {
            //     return [<span>{row['originalAmount']}</span>];
            //   },
            //   edit: ({ row }) => {
            //     return [
            //       <InputNumberAd
            //         value={row['originalAmount']}
            //         max={999999999.999999}
            //         min={0}
            //         precision={6}
            //         onInput={(val) => this.updateCol(row, val, 'originalAmount')}
            //       ></InputNumberAd>,
            //     ];
            //   },
            // },
            width: 180,
          },
          {
            field: 'currencyName',
            title: '币种',
            width: 120,
          },
          {
            field: 'exchangeRate',
            title: '汇率',
            width: 120,
          },
          {
            field: 'domesticAmount',
            title: '本币结算金额（含税）',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
                disabled: true,
              },
            },
            width: 180,
          },
          {
            field: 'additional',
            title: '附加',
            editRender: {
              name: 'ElCheckbox',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<ElCheckbox value={row['additional']}></ElCheckbox>];
              },
              edit: ({ row }) => {
                return [
                  <ElCheckbox
                    onChange={(val) => this.updateCol(val, row, 'additional')}
                  ></ElCheckbox>,
                ];
              },
            },
            width: 100,
          },
          {
            field: 'businessDocNo',
            title: '业务单据编号',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
                disabled: true,
              },
            },
            width: 120,
          },
          {
            field: 'remark',
            title: '备注',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            width: 120,
          },
        ];
      },
    },
    methods: {
      // 表格底部
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            if (['originalAmount'].includes(column.property)) {
              return data.reduce((cur, next) => cur + +next.originalAmount, 0);
            }
            if (['domesticAmount'].includes(column.property)) {
              return data.reduce((cur, next) => cur + +next.domesticAmount, 0).toFixed(2);
            }
            return '-';
          }),
        ];
      },
      // 更新列
      updateCol(row, fieldValue, field) {
        console.log(row, fieldValue, field, '====>');
        row[field] = fieldValue;
        if (field == 'settlementQuantity' || field == 'originalPrice') {
          row['originalAmount'] = row['settlementQuantity'] * row['originalPrice'];
          row['domesticAmount'] = row['originalAmount'] * row['exchangeRate'];
        }
      },
      // 关闭的时候
      closeEditTableHandler() {
        // 获取表格数据,抛出去
        const $table = this.$refs.xTableRef;
        const tableData = $table.getTableData().fullData;
        this.$emit('closeEditTableHandler', tableData);
      },
      handleSelectionChange({ row }) {
        console.log(row, '111');
        if (!this.isHiddenBtn) {
          this.selectionList = [row];
          this.closeEditTableHandler();
          console.log(this.selectionList, '11111==>');
          this.$emit('selectionRowHandler', row);
        }
      },
      // 新增一行
      async addNewRowHandler() {
        const { currencyName, exchangeRate } = this.baseFormData;
        if (!currencyName || !exchangeRate) {
          this.$message.error('请先添加表单数据');
          return;
        }
        const $table = this.$refs.xTableRef;
        const { row } = await $table.insertAt(
          {
            currencyName,
            exchangeRate,
            expenseTypeName: '监管费',
            expenseType: '01',
          },
          0
        );
        await $table.setActiveRow(row);
      },
      // 删除行
      deleteBtnClickHandler() {
        if (!this.selectionList.length) {
          this.$message.error('请选择行再删除');
          return;
        }
        const XIDList = this.selectionList.map((item) => item._XID);
        const idList = this.selectionList.map((item) => item.id).filter((item) => Boolean(item));
        this.ids = [...this.ids, ...idList];
        this.tableData = this.getTableData().filter((item) => !XIDList.includes(item._XID));
        this.$emit('deleteRowDataHandler', this.tableData);
      },
      //校验
      async validAllEvent() {
        const $table = this.$refs.xTableRef;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (errMap) {
          this.$message.error('请检查结算行数据');
          return true;
          // this.checkStatus = true;
        } else {
          return false;
          // this.checkStatus = false;
        }
      },
      // 获取表格数据
      getValidateTableData() {
        this.closeEditTableHandler();
        return new Promise((resolve) => {
          const $table = this.$refs.xTableRef;
          const tableData = $table.getTableData().fullData;
          $table.validate(() => {
            const currentStatus = this.$route.query.status;
            const formTableData = tableData.map((item) => {
              return {
                ...item,
                departmentCode: this.userInfo.departmentCode,
                departmentName: this.userInfo.departmentName,
                companyCode: this.userInfo.companyCode,
                companyName: this.userInfo.companyName,
                // 特殊处理id
                id:
                  ['create', 'renew'].includes(currentStatus) && this.contractStatus != '01'
                    ? ''
                    : item?.id,
              };
            });
            resolve({ tableData: formTableData, deleteStorageLineIds: this.ids });
          });
        });
      },
      getTableData() {
        const $table = this.$refs.xTableRef;
        return $table.getTableData().fullData;
      },
      fullTableData(tableData) {
        this.tableData = tableData;
      },
    },
    watch: {
      isCreate: {
        handler(val) {
          this.isHiddenBtn = !val;
          this.editConfig = val ? { trigger: 'click', mode: 'row' } : {};
        },
        immediate: true,
      },
      fetchTableData: {
        handler(val) {
          if (val && val.length) {
            this.fullTableData(val);
          } else {
            this.fullTableData([]);
          }
        },
        immediate: true,
      },
      defaultSelection: {
        handler(val) {
          console.log(val, '监听');
          if (val && Object.keys(val).length > 0) {
            this.selectionList = [val];
            this.$refs.xTableRef.setRadioRow(val);
          }
        },
        immediate: true,
        deep: true,
      },
    },
  };
</script>

<style></style>
